export const TALISMAN_REQUIREMENTS = [8, 12, 16, 20, 24, 28, 36, 40, 44, 50];

/** Talizmany — logika w talismansFirestore.js (Firestore, bez Cloud Functions). */
export const getTalismansApiBase = () => '';

/** Pełny URL endpointu talizmanów (unika podwójnego /api). */
export const talismansUrl = (path = '') => {
  const base = getTalismansApiBase();
  const suffix = String(path).replace(/^\//, '');
  if (base) {
    return suffix ? `${base}/talismans/${suffix}` : `${base}/talismans`;
  }
  return suffix ? `/api/talismans/${suffix}` : '/api/talismans';
};

export const buildClaimableTalismans = (totalTokens, ownedIds = []) => {
  const owned = new Set(ownedIds.map(Number));
  return TALISMAN_REQUIREMENTS
    .map((req, index) => ({ id: index + 1, req }))
    .filter(({ id, req }) => totalTokens >= req && !owned.has(id))
    .map(({ id }) => id);
};
